import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Calendar, Plus } from '@phosphor-icons/react';
import { SessionCard } from './SessionCard';

/**
 * SessionList - Display list of sessions with empty state
 */
export function SessionList({
  sessions,
  locations,
  showDraftsOnly,
  onViewRoster,
  onViewWaitlist,
  onEdit,
  onDelete,
  onCancel,
  onRestore,
  onPublish,
  onUnpublish,
  onExportCSV,
  onCopy,
  onMessage,
  onViewPhotos,
  onEndSession,
  onReopenSession,
  onAddSession,
  cancellingSession
}) {
  // Filter sessions based on draft toggle
  const filteredSessions = showDraftsOnly 
    ? sessions.filter(s => s.published === false)
    : sessions;

  if (sessions.length === 0) {
    return (
      <Card className="bg-card border-border">
        <CardContent className="text-center py-12">
          <Calendar size={48} weight="duotone" className="mx-auto text-muted-foreground mb-4" />
          <h3 className="font-heading text-lg mb-2">NO SESSIONS YET</h3>
          <p className="text-muted-foreground mb-4">
            Create your first basketball session to get started.
          </p>
          {locations.length === 0 ? (
            <div>
              <p className="text-sm text-muted-foreground mb-4">
                You need to add locations first.
              </p>
              <Button 
                onClick={() => window.location.href = '/admin/locations'}
                className="btn-primary"
              >
                Add Locations
              </Button>
            </div>
          ) : (
            <Button 
              onClick={onAddSession}
              className="btn-primary"
              data-testid="empty-state-add-session-btn"
            >
              <Plus size={20} weight="bold" className="mr-2" />
              Create First Session
            </Button>
          )}
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4 stagger-children">
      {filteredSessions.map((session) => (
        <SessionCard
          key={session.session_id}
          session={session}
          onViewRoster={onViewRoster}
          onViewWaitlist={onViewWaitlist}
          onEdit={onEdit}
          onDelete={onDelete}
          onCancel={onCancel}
          onRestore={onRestore}
          onPublish={onPublish}
          onUnpublish={onUnpublish}
          onExportCSV={onExportCSV}
          onCopy={onCopy}
          onMessage={onMessage}
          onViewPhotos={onViewPhotos}
          onEndSession={onEndSession}
          onReopenSession={onReopenSession}
          cancellingSession={cancellingSession}
        />
      ))}
    </div>
  );
}
